import { AttrDepsHandler } from "../AttrDepsHandler";

/* eslint no-param-reassign: "off" */

export const linkedValueHandler: AttrDepsHandler = {
  search: (attr) => {
    const { pathValue } = attr;
    return pathValue?.[0] ? [pathValue[0]] : [];
  },
  replace: (attr, meta) => {
    const { pathValue } = attr;
    if (pathValue?.[0]) {
      const newId = meta.attrSrcToDst[pathValue[0]];
      if (newId) {
        pathValue[0] = newId;
      }
    }
  },
};
